import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '@/lib/api';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';

export default function RegisterIndividualPage() {
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: '', email: '', password: '', liceo_name: '' });
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    async function handleSubmit(e: FormEvent) {
        e.preventDefault();
        setSubmitting(true);
        setError(null);
        try {
            await authApi.registerIndividual({
                name: form.name.trim(),
                email: form.email.trim().toLowerCase(),
                password: form.password,
                liceo_name: form.liceo_name.trim() || undefined,
            });
            navigate('/admin/dashboard', { replace: true });
        } catch (err) {
            setError((err as Error).message);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
            <div className="w-full max-w-md bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 space-y-6">
                <div className="text-center">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Crear cuenta individual</h1>
                    <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                        Tu cuenta personal en ConexEd. Vas a ser administrador/a de tu propio espacio.
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <Input
                        label="Nombre completo"
                        required
                        minLength={2}
                        maxLength={200}
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                    />
                    <Input
                        label="Email"
                        type="email"
                        required
                        maxLength={200}
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                    />
                    <Input
                        label="Contraseña"
                        type="password"
                        required
                        minLength={6}
                        maxLength={128}
                        hint="Mínimo 6 caracteres"
                        value={form.password}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                    />
                    <Input
                        label="Nombre de tu espacio (opcional)"
                        maxLength={200}
                        placeholder="Ej: Mi Colegio Personal"
                        hint="Si lo dejas vacío usaremos tu email."
                        value={form.liceo_name}
                        onChange={(e) => setForm({ ...form, liceo_name: e.target.value })}
                    />

                    {error && (
                        <div className="text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 px-3 py-2 rounded-lg">
                            {error}
                        </div>
                    )}

                    <Button type="submit" loading={submitting} className="w-full">
                        Crear mi cuenta
                    </Button>
                </form>

                <p className="text-center text-xs text-gray-500 dark:text-gray-400">
                    Al crear tu cuenta aceptas nuestra{' '}
                    <a href="/general/privacidad.html" className="text-brand-blue hover:underline">política de privacidad</a>.
                </p>
                <p className="text-center text-xs">
                    <Link to="/login" className="text-brand-blue hover:underline">Volver al login</Link>
                </p>
            </div>
        </div>
    );
}
